import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@deephaven/components';
import { vsPass, vsWarning } from '@deephaven/icons';
import { TextUtils } from '@deephaven/utils';
import "./ChartFilterOverlay.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ChartFilterOverlay(_ref) {
  var columnMap = _ref.columnMap,
    inputFilterMap = _ref.inputFilterMap,
    linkedColumnMap = _ref.linkedColumnMap,
    onAdd = _ref.onAdd,
    onOpenLinker = _ref.onOpenLinker,
    waitingFilterMap = _ref.waitingFilterMap,
    waitingInputMap = _ref.waitingInputMap;
  var inputMessage = useMemo(() => {
    var waitingColumns = Array.from(waitingInputMap.keys());
    var needsInputFilterValue = waitingColumns.find(columnName => inputFilterMap.get(columnName) != null);
    var needsLinkValue = waitingColumns.find(columnName => linkedColumnMap.get(columnName) != null);
    var columnsText = TextUtils.join(waitingColumns.map(item => "\"".concat(item, "\"")));
    if (needsInputFilterValue != null && needsInputFilterValue && needsLinkValue != null && needsLinkValue) {
      return "Use a filter control or linked table to set a value for ".concat(columnsText);
    }
    if (needsInputFilterValue != null && needsInputFilterValue) {
      return "Set a filter control value for ".concat(columnsText);
    }
    return "Double click a row in a linked table to set a value for ".concat(columnsText);
  }, [inputFilterMap, linkedColumnMap, waitingInputMap]);
  var columns = useMemo(() => Array.from(columnMap.values()), [columnMap]);
  var handleAddClick = useCallback(event => {
    event.stopPropagation();
    event.preventDefault();
    onAdd(Array.from(waitingFilterMap.values()));
  }, [onAdd, waitingFilterMap]);
  var handleOpenLinker = useCallback(event => {
    event.stopPropagation();
    event.preventDefault();
    onOpenLinker();
  }, [onOpenLinker]);
  var isWaitingFilters = waitingFilterMap.size > 0;
  var isWaitingInput = !isWaitingFilters && waitingInputMap.size > 0;
  return /*#__PURE__*/_jsx("div", {
    className: "chart-panel-overlay chart-filter-overlay",
    children: /*#__PURE__*/_jsxs("div", {
      className: classNames('chart-panel-overlay-content chart-filter-overlay-content', {
        'chart-filter-waiting-filter': isWaitingFilters
      }, {
        'chart-filter-waiting-input': isWaitingInput
      }),
      children: [isWaitingFilters && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "info-message",
          children: "This plot requires a filter control to be added to the layout or a table link to be created on the following columns:"
        }), /*#__PURE__*/_jsx("div", {
          className: "waiting-filter-list",
          children: columns.map(column => {
            var isColumnWaiting = waitingFilterMap.has(column.name);
            var icon = isColumnWaiting ? vsWarning : vsPass;
            return /*#__PURE__*/_jsxs("div", {
              className: classNames('waiting-filter-item', {
                'is-invalid': isColumnWaiting
              }),
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: icon
              }), column.name]
            }, column.name);
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "primary",
            onClick: handleAddClick,
            children: "Add Input Filters"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "primary",
            onClick: handleOpenLinker,
            children: "Open Linker Tool"
          })]
        })]
      }), isWaitingInput && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "info-message",
          children: "Waiting for User Input"
        }), /*#__PURE__*/_jsx("div", {
          className: "",
          children: inputMessage
        })]
      })]
    })
  });
}
export default ChartFilterOverlay;
//# sourceMappingURL=ChartFilterOverlay.js.map